import React from 'react';
import LibPhoneInput from 'react-phone-input-2';
import styles from './PhoneInput.module.css';
import 'react-phone-input-2/lib/style.css';

interface PhoneInputProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => any;
  error?: string;
}

function PhoneInput({ id, label, onChange, value, error }: PhoneInputProps) {
  return (
    <div className={styles['text-field-wrapper']}>
      <label className={styles['phone-label']} htmlFor={id}>
        {label}
      </label>
      <LibPhoneInput
        country="us"
        value={value}
        containerClass={styles['phone-input-container']}
        inputClass={styles['phone-input']}
        onChange={(val) => {
          onChange(val);
        }}
      />
      {error && <div className="errorMessage">{error}</div>}
    </div>
  );
}

export default PhoneInput;
